import { makeAutoObservable } from 'mobx';

import { defaultTelemetryState, TelemetryState } from '../simulator/useSimulatorTelemetry';

export class PilotTelemetryStore {
  telemetry: TelemetryState = { ...defaultTelemetryState };
  path: { lat: number; lon: number }[] = [];
  home: { lat: number; lon: number } = { lat: 0, lon: 0 };

  constructor() {
    makeAutoObservable(this);
    this.path.push({ lat: this.telemetry.lat, lon: this.telemetry.lon });
    this.setHomePosition({ lat: defaultTelemetryState.lat, lon: defaultTelemetryState.lon });
  }

  updateTelemetry(partial: Partial<TelemetryState>) {
    this.telemetry = { ...this.telemetry, ...partial };
  }

  addPathPoint(lat: number, lon: number) {
    this.path.push({ lat, lon });
  }

  setHomePosition({ lat, lon }: { lat: number; lon: number }) {
    this.home = { lat, lon };
  }

  reset() {
    this.telemetry = { ...defaultTelemetryState };
    this.path = [{ lat: this.telemetry.lat, lon: this.telemetry.lon }];
  }

  async setStartLocation(address: string) {
    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        this.reset();
        this.updateTelemetry({ lat: parseFloat(lat), lon: parseFloat(lon) });
        this.setHomePosition({ lat: defaultTelemetryState.lat, lon: defaultTelemetryState.lon });
      }
    } catch (err) {
      console.error('Failed to geocode start location', err);
    }
  }
}

export const pilotTelemetryStore = new PilotTelemetryStore();
